export default __webpack_public_path__ + "static/media/resurs_med_konto_ikon.dad69d24.png";